/**
 * MapFilter
 */

import React, { useContext } from 'react';
import Select, { components } from 'react-select';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/actionCreators';

const MenuListContext = React.createContext({
    onClearFilter: () => {},
    onCloseFilter: () => {}
});

class MapFilter extends React.Component {
    constructor(props) {
        super(props);

        this.selectRef = React.createRef();
        this.state = {
            hasMounted: false,
            closeButtonActive: false,
            closeButtonVisible: false,
            filter: [...props.filter],
            selectOpen: false,
            isDepositActive: false,
            selectedFilters: [],
        };
    }

    clearFilter = () => {
        this.props.setFilter(this.props.options);
        const newUrl = `${window.location.pathname}`;
        history.pushState({ path: newUrl }, '', newUrl);
        this.updateSelectedFilters([]);
    };

    closeFilter = () => {
        this.setState({ selectOpen: false });
    };

    componentDidMount() {
        this.setState({
            hasMounted: true
        });
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filter !== this.props.filter) {
            this.updateSelectedFiltersCount(this.props.filter);
        }
    }

    handleClickOutside = (event) => {
        if (
            this.selectRef.current &&
            !this.selectRef.current.contains(event.target)
        ) {
            this.setState({ selectOpen: false });
        }
    };

    showCloseButton = () => {
        this.setState({
            closeButtonVisible: true,
            closeButtonActive: true
        });
    };

    hideClosebutton = () => {
        this.setState({
            closeButtonVisible: false
        });

        setTimeout(() => {
            this.setState({
                closeButtonActive: false
            });
        }, 1000);
    };

    handleMenuOpen = () => {
        this.setState({
            selectOpen: true
        });
    };

    handleMenuClose = () => {
        this.setState({
            selectOpen: false
        });
    };

    handleToggleMenu = () => {
        this.setState((prevState) => ({
            selectOpen: !prevState.selectOpen
        }));
    };

    // function for toggeling on click filter by deposit
    toggleDeposit = () => {
        const { onFilterChange } = this.props;
        onFilterChange('deposit');
        this.setState({ isDepositActive: !this.state.isDepositActive });
    };

    updateSelectedFiltersCount = (newFilter) => {
        const selectedCount = newFilter.reduce((count, group) => {
            if (group.id === "deposit") {
                return count;
            }
            return count + group.options.filter((option) => option.active).length;
        }, 0);
        this.setState({ selectedFiltersCount: selectedCount });
    };

    render() {
        const { isDepositActive, selectedFiltersCount } = this.state;
        const { labels, filter, options, onFilterChange, hideList, items } =
            this.props;
        const customStyles = {
            indicatorsContainer: (provided) => ({
                ...provided,
                display: 'none'
            }),
            menu: (provided) => ({
                ...provided,
                minWidth: '343px',
                borderRadius: '4px',
                boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.18)'
            }),
            placeholder: (provided) => ({
                ...provided,
                color: 'rgb(3, 54, 103)'
            }),
        };

        const handleGroupChange = (event, optionId) => {
            this.props.onFilterChange(optionId);
            this.updateSelectedFiltersCount(this.props.filter);
        };

        const handleOptionChange = (event, optionId) => {
            this.props.onFilterChange(optionId, true);
            this.updateSelectedFiltersCount(this.props.filter);
        };

        const placeholderText = this.state.selectedFiltersCount > 0 ? `${this.state.selectedFiltersCount} valda` : 'Ta ut';
        return (
            <MenuListContext.Provider
                value={{
                    onClearFilter: this.clearFilter,
                    onCloseFilter: this.closeFilter
                }}
            >
                <div className="MapFilter">
                    {this.state.hasMounted && items.length > 0 && (
                        <div ref={this.selectRef} className="MapFilter__SelectContainer">
                            <Select
                                menuIsOpen={this.state.selectOpen}
                                className="MapFilter__Select"
                                styles={customStyles}
                                options={options}
                                placeholder={placeholderText}
                                components={{
                                    MenuList,
                                    GroupHeading: (props) => (
                                        <GroupHeading
                                            {...props}
                                            filter={this.props.filter}
                                            handleGroupChange={
                                                handleGroupChange
                                            }
                                        />
                                    ),
                                    Option: (props) => (
                                        <Option
                                            {...props}
                                            filter={this.props.filter}
                                            handleOptionChange={
                                                handleOptionChange
                                            }
                                        />
                                    ),
                                    ValueContainer
                                }}
                                isSearchable={false}
                                tabIndex={0}
                                openOnFocus={true}
                                onFocus={hideList}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                controlShouldRenderValue={false}
                                onMenuOpen={this.handleMenuOpen}
                                onMenuClose={this.handleMenuClose}
                                onClick={this.handleToggleMenu}
                            />
                        </div>
                    )}
                    {this.state.hasMounted && (
                        <>
                            <label
                                className={classNames(
                                    'MapFilter__DepositButton',
                                    { 'MapFilter__DepositButton--active': isDepositActive }
                                )}>
                                <input
                                    type="checkbox"
                                    onClick={this.toggleDeposit}
                                />
                                <span className="MapFilter__CheckmarkText">
                                    Sätt in SEK
                                </span>
                            </label>
                        </>
                    )}
                </div>
            </MenuListContext.Provider>
        );
    }
}

const MenuList = (props) => {
    const { onClearFilter, onCloseFilter } = useContext(MenuListContext);
    return (
        <components.MenuList {...props}>
            <div className="MapFilter__SelectDropdown">
                {props.children}
                <div className="MapFilter__SelectButtons">
                    <button
                        className="MapFilter__SelectButtonSecondary"
                        onClick={onClearFilter}
                    >
                        Rensa val
                    </button>
                    <button
                        className="MapFilter__SelectButton"
                        onClick={onCloseFilter}
                    >
                        Stäng filter
                    </button>
                </div>
            </div>
        </components.MenuList>
    );
};

const GroupHeading = (props) => {
    const { filter, data, children, handleGroupChange } = props;
    const groupData = filter.find((group) => group.id === data.id);
    const isChecked = groupData && groupData.active;

    if (data.value === 'deposit') {
        return null;
    }

    if (data.options.length <= 1) {
        return (
            <div className={classNames(
                'MapFilter__GroupHeading',
                { [`MapFilter__GroupHeading--${data.value}`]: data.value }
            )}>
                <label>{children}</label>
            </div>
        );
    }

    return (
        <div className='MapFilter__HeadingContainer'>
            <input
                id={data.value}
                value={data.value}
                type="checkbox"
                checked={isChecked}
            />
            <label
                onClick={(e) => handleGroupChange(e, data.id)}
                for={data.value}
                className={classNames(
                    'MapFilter__GroupHeading',
                    { [`MapFilter__GroupHeading--${data.value}`]: data.value }
                )}
            >
                {children}
            </label>
            <span className='MapFilter__HeadingCheckMark'></span>
        </div>
    );
};

const Option = (props) => {
    const { filter, data, handleOptionChange } = props;
    const matchingOption = filter.find((item) =>
        item.options.some((option) => option.id === data.id && option.active)
    );

    const isChecked = matchingOption
        ? matchingOption.options.find((option) => option.id === data.id).active
        : false;

    if (data.id === 'deposit_') {
        return null;
    }

    return (
        <div className='MapFilter__Option'>
            <input
                id={data.id}
                value={data.value}
                type="checkbox"
                checked={isChecked}
            />
            <label
                onClick={(e) => handleOptionChange(e, data.id)}
                htmlFor={data.id}
            >
                {data.label}
            </label>
            <span className='MapFilter__CheckMark'></span>
        </div>
    );
};

const ValueContainer = ({ children, ...props }) => {
    const selectedOption = props.getValue()[0];

    return (
        <components.ValueContainer
            {...props}
            className={classNames('MapFilter__ValueContainer', {
                [`MapFilter__ValueContainer--${selectedOption && selectedOption.value}`]:
                    selectedOption !== undefined
            })}
        >
            {children}
        </components.ValueContainer>
    );
};

MapFilter.defaultProps = {
    options: [],
    labels: {}
};

function mapStateToProps(state) {
    return {
        items: state.map.items
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MapFilter);
